import React from 'react';
import Zoom from 'react-reveal/Zoom';

import Text from '../../../common/components/Text';
import Image from '../../../common/components/Image';
import Button from '../../../common/components/Button';
import Heading from '../../../common/components/Heading';
import Container from '../../../common/components/UI/Container';
import Section, {
  ContentWrapper,
  BannerContent,
  Illustration,
  ButtonGroup,
  TrustedBy,
  ImageGroup,
} from './banner.style';

import paypal from '../../../common/assets/image/donation/banner/paypal.png';
import google from '../../../common/assets/image/donation/banner/google.png';
import dropbox from '../../../common/assets/image/donation/banner/dropbox.png';

const Banner = () => {
  return (
    <Section id="home">
      <ContentWrapper>
        <Container>
          <BannerContent>
            <Heading
              as="h1"
              content="Choose your game"
            />
            <Text
              className="banner-caption"
              content="Decentralized 'heads or tails' games, you vs other players. Invite your friends and see who wins most!"
            />
            <ButtonGroup>
              <a href="/hot/bnb">
              <Button title="BNB HOT" />
              </a>
              <a href="/hot/token/0x9C9Ac8B098A7D47ED1834599ce2DC29cb94103e9">
              <Button title="BEP-20 MSC HOT" className="button-white" />
              </a>
            </ButtonGroup>
            {/* <TrustedBy>
              <Text content="Trusted by:" />
              <ImageGroup>
                <Image src={paypal} alt="paypal" />
                <Image src={google} alt="google" />
                <Image src={dropbox} alt="dropbox" />
              </ImageGroup>
            </TrustedBy> */}
          </BannerContent>
        </Container>
        <Illustration />
      </ContentWrapper>
    </Section>
  );
};

export default Banner;
